import { lazy, ComponentType } from 'react'

import trackEvent from 'lib/trackEvent'

export const lazyWithErrorHandling = <T = any,>(
  importFunc: () => Promise<{ default: ComponentType<T> }>
) =>
  lazy(() =>
    importFunc().catch((err) => {
      window.console.error(err)
      return {
        default: () => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginTop: '20px',
            }}
            data-testid="auto-id-a4d54b84-0b43-4a6a-8852-cb32fe1575c4"
          >
            <div data-testid="auto-id-06726cb2-a9a4-4faf-9069-d5f8a22238ef">
              Unable to load
            </div>
            <br data-testid="auto-id-96139466-ee8e-4717-b4f0-c4480adb82fe" />
            <div
              style={{
                cursor: 'pointer',
                border: '1px solid rgb(204, 204, 204)',
                padding: '6px',
                borderRadius: '4px',
                backgroundColor: '#646363',
                color: 'white',
              }}
              onClick={() => {
                try {
                  trackEvent(
                    trackEvent.modules.auth,
                    trackEvent.events.reload_lazy_click
                  )
                  window.location.reload()
                } catch (error) {
                  console.error('Error tracking event:', error)
                }
              }}
              data-testid="auto-id-29c515a5-4dbd-4133-8907-df758ec99b42"
            >
              RETRY
            </div>
          </div>
        ),
      }
    })
  )
